import React, { useEffect, useRef, useState } from 'react';

// Dropdown de seleção COM busca, visualmente idêntico aos <select> dos filtros
// do DRE (mesmo trigger + chevron), porém com campo de busca e lista rolável.
// Substitui o <input list=datalist>, cujo menu nativo diverge entre navegadores.
// options: [{ value, label }]; value = '' representa "todas".
function DreUnidadeSelect({ options, value, onChange, placeholder = 'Todas' }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const wrapRef = useRef(null);

  // Fecha ao clicar fora.
  useEffect(() => {
    function onDocClick(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const selected = options.find(o => o.value === value) || null;
  const termo = query.trim().toLowerCase();
  const filtradas = termo
    ? options.filter(o => o.label.toLowerCase().includes(termo))
    : options;

  const escolher = (v) => {
    onChange(v);
    setOpen(false);
    setQuery('');
  };

  return (
    <div className="dre-combo" ref={wrapRef}>
      <button
        type="button"
        className={`dre-combo-trigger${open ? ' is-open' : ''}`}
        onClick={() => setOpen(o => !o)}
      >
        <span className={selected ? 'dre-combo-val' : 'dre-combo-ph'}>
          {selected ? selected.label : placeholder}
        </span>
      </button>

      {open && (
        <div className="dre-combo-panel">
          <input
            type="text"
            className="dre-combo-search"
            placeholder="Buscar unidade..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            autoFocus
          />
          <ul className="dre-combo-list">
            <li>
              <button
                type="button"
                className={`dre-combo-opt${!value ? ' selected' : ''}`}
                onClick={() => escolher('')}
              >
                {placeholder}
              </button>
            </li>
            {filtradas.length === 0 ? (
              <li className="dre-combo-empty">Nenhuma unidade encontrada.</li>
            ) : filtradas.map(o => (
              <li key={o.value}>
                <button
                  type="button"
                  className={`dre-combo-opt${o.value === value ? ' selected' : ''}`}
                  onClick={() => escolher(o.value)}
                >
                  {o.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default DreUnidadeSelect;
